// extracted by mini-css-extract-plugin
export var bubble = "_1k-0";
export var container = "_1k-3";
export var contrastBorder = "_1k-4";
export var greyOut = "_1k-2";
export var initialsWrapper = "_1k-1";
export var large = "_1k-9";
export var medium = "_1k-8";
export var mediumSmall = "_1k-7";
export var mediumSmallMedium = "_1k-c";
export var micro = "_1k-5";
export var small = "_1k-6";
export var tiny = "_1k-b";
export var xTiny = "_1k-a";